import CamionesRechazadosEnCalado from '../../../../../../models/calado/camiones_rechazados'
import { getColumnasRechazosAdministrativos, COLUMNS_RECHAZOS_ADMINISTATIVOS_TO_PRINT } from './constantesCamionesRechazadosAdministrativamente'
import { TABLA_CAMIONES_RECHAZADOS_ADMINISTRATIVAMENTE } from '../../../../../../config/tables'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'
import { toast } from 'react-toastify'
import moment from 'moment'

export function obtenerCamionesRechazadosAdmEnCalado (fechaDesde, fechaHasta, rol = null) {
  return (dispatch) => {
    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')

    CamionesRechazadosEnCalado.consultaCamionesRechazadosAdmEnCaladoPorFecha(fechaD, fechaH).then(callback)
    function callback (result) {
      const data = []
      result.forEach(d => { data.push({ ...d, cartadeporte: d.cartaDePorteAutomotor }) })
      const fecha = (fechaD === fechaH)
        ? `el ${moment(fechaD).format('DD-MM-YYYY')}`
        : `entre ${moment(fechaD).format('DD-MM-YYYY')} y ${moment(fechaH).format('DD-MM-YYYY')}`
      const textRowCount = `Cantidad de rechazos administrativos con fecha de calado ${fecha} :`

      const customToolbar = pdfCustomToolbarGenerator(
        'Listado de camiones rechazados administrativamente',
        data,
        COLUMNS_RECHAZOS_ADMINISTATIVOS_TO_PRINT,
        'landscape'
      )
      const columnas = getColumnasRechazosAdministrativos(rol)

      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: columnas,
          data: data,
          title: `Camiones rechazados administrativamente`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            filter: true,
            pagination: false,
            showRowCount: true,
            textRowCount,
            tableBodyMaxHeight: '499px'
          }
        },
        id: TABLA_CAMIONES_RECHAZADOS_ADMINISTRATIVAMENTE
      })
    }
    toast.info('Operación realizada exitosamente.')
  }
}
